import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { AlertService } from 'src/app/public/services/alert.service';
import { ApiService } from 'src/app/public/services/api.service';
import { Suggestion } from 'src/app/public/socio-emotional-skills-test/socio-emotional-skills-test.models';

const COMPLETE_SUGGESTION_URL = 'api/socioEmotionalSuggestionProgress/complete';
const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',

  // Word
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

  // Excel
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

  // PowerPoint
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation'
];
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
@Component({
  selector: 'app-socio-emotional-skills-test-results-suggestions-complete-form',
  templateUrl: './socio-emotional-skills-test-results-suggestions-complete-form.component.html',
  styleUrls: ['./socio-emotional-skills-test-results-suggestions-complete-form.component.scss']
})
export class SocioEmotionalSkillsTestResultsSuggestionsCompleteFormComponent implements OnInit {
  @Input() suggestion: Suggestion;

  form: FormGroup;
  selectedFile: File | null = null;
  fileName = '';
  isSubmitting = false;

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private alertService: AlertService,
    private dialogRef: MatDialogRef<SocioEmotionalSkillsTestResultsSuggestionsCompleteFormComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { suggestion: Suggestion }
  ) {
    if (this.data && this.data.suggestion) {
      this.suggestion = this.data.suggestion;
    }
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      reflection: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
  
    if (file) {
      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        this.alertService.showError({
          msg: 'Tipo de archivo no permitido. Solo se permiten imágenes (JPG, PNG), PDF, Word, Excel y PowerPoint.'
        });
        this.selectedFile = null;
        this.fileName = '';
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        this.alertService.showError({
          msg: 'El archivo es demasiado grande. Tamaño máximo permitido: 5MB.'
        });
        this.selectedFile = null;
        this.fileName = '';
        return;
      }
  
      this.selectedFile = file;
      this.fileName = file.name;
    }
    
  }
  

  submit(): void {
    if (this.form.invalid || !this.selectedFile) return;

    this.isSubmitting = true;

    const formData = new FormData();
    formData.append('reflection', this.form.get('reflection')?.value);
    formData.append('file', this.selectedFile);

    this.apiService.postFormData({ api: `${COMPLETE_SUGGESTION_URL}/${this.suggestion._id}`, formData })
      .subscribe({
        next: (res) => {
          this.alertService.showSuccess({ msg: '¡Sugerencia marcada como completada con evidencia!' });
          this.suggestion.completed = true;
          this.isSubmitting = false;
          this.dialogRef.close(true);  
        },
        error: (err) => {
          console.error('Error al enviar sugerencia completa:', err);
          this.alertService.showError({ msg: 'Error al marcar la sugerencia como completada.' });
          this.isSubmitting = false;
        }
      });
  }
}
